import {
  Emphases,
  LabelIds,
  Perspectives,
  RowIds,
  SectionIds,
  TooltipIds,
} from "../consts";
import { defineRows } from "../defineRows";
import { earningsTotalLabel, hostFeeLabel } from "./labelRules";

/**
 * Section 2 — host earnings.
 * Order (Rules Sheet): Earnings subtotal → host platform fee → Taxes → Earnings total.
 * Same three rows for DIY and FSV when facts are present; DIY labels stay Service fee / Earnings.
 * The total reads `estimatedEarnings` (fee basis less fee), not `payout`, so it
 * survives pay-at-venue bookings where Peerspace pays out nothing.
 */
const hostEarningsRows = defineRows(SectionIds.HostEarnings, {
  earnings: [
    {
      // 1 - Earnings subtotal - FSV only
      id: RowIds.EarningsSubtotal,
      amount: (facts) => facts.earningsSubtotal,
      show: (facts) => !facts.isDiy && facts.earningsSubtotal !== null,
      perspective: Perspectives.Host,
      label: () => ({ id: LabelIds.EarningsSubtotal }),
      tooltipId: () => TooltipIds.EarningsSubtotal,
    },
    {
      // 2 - Host fee
      id: RowIds.HostFee,
      amount: (facts) => facts.hostPlatformFeeAmount,
      show: (facts) => facts.hostPlatformFeeAmount !== null && facts.hostPlatformFeeAmount !== 0,
      perspective: Perspectives.Host,
      label: (facts) => hostFeeLabel(facts),
      negative: true,
      tooltipId: (facts) =>
        facts.isDiy ? TooltipIds.DiyHostFee : TooltipIds.FsvHostFee,
    },
    {
      id: RowIds.VatTaxes,
      amount: (facts) => facts.hostVatAmount,
      negative: true,
      perspective: Perspectives.Host,
      label: () => ({ id: LabelIds.Taxes }),
      allowZero: false,
      tooltipId: (facts) =>
        facts.isDiy ? TooltipIds.DiyHostVatTaxes : TooltipIds.FsvHostVatTaxes,
    },
    {
      // 3 - Earnings total - FSV only
      id: RowIds.EstimatedEarnings,
      amount: (facts) => facts.estimatedEarnings,
      // Renders $0.00 when the fee consumes the basis — the section's
      // subtotal − fee arithmetic has to stay readable.
      allowZero: true,
      show: (facts) => !facts.isDiy && facts.estimatedEarnings !== null,
      perspective: Perspectives.Host,
      label: (facts) => earningsTotalLabel(facts),
      emphasis: Emphases.Strong,
    },
  ],
});

export { hostEarningsRows };
